import { createSlice } from '@reduxjs/toolkit';

interface MaterialRequestState {
	materialRequestModalVisible: boolean;
}

const initialState: MaterialRequestState = {
	materialRequestModalVisible: false,
};

export const materialRequest = createSlice({
	name: 'materialRequest',
	initialState,
	reducers: {
		showMaterialRequestModal: (state) => {
			state.materialRequestModalVisible = true;
		},
		closeMaterialRequestModal: (state) => {
			state.materialRequestModalVisible = false;
		},
	},
});

// Action creators are generated for each case reducer function
export const { showMaterialRequestModal, closeMaterialRequestModal } =
	materialRequest.actions;

export default materialRequest.reducer;
